import { Dispatch, SetStateAction, useState } from "react";

const getStorageValue = <T>(key: LocalStorageKey | string, defaultValue?: T): any => {
    try {
        const item = localStorage.getItem(key);
        return item ? (JSON.parse(item) as T) : defaultValue;
    } catch (err) {
        return defaultValue;
    }
};

export const useLocalStorage = <T>(
    key: LocalStorageKey | string,
    defaultValue: T | null = null
): [T, SetValue<T>, () => void] => {
    const [value, setValue] = useState(() => getStorageValue(key, defaultValue));

    const setStorageValue = (newValue: any): void => {
        localStorage.setItem(key, JSON.stringify(newValue));

        setValue(newValue);
    };

    const removeStorageValue = (): void => {
        localStorage.removeItem(key);

        setValue(null);
    };

    return [value, setStorageValue, removeStorageValue];
};

type SetValue<T> = Dispatch<SetStateAction<T>>;

export const enum LocalStorageKey {
    AssessmentBasket = "assessmentBasket",
    LoginRedirect = "loginRedirect"
}
